module Meevo.Plugins.Tax {
    "use strict";

    /**
    * Main Section of tax and currency
    */
    export class MainSection extends Meevo.Components.CommonClasses.CommonSectionBase {

        public taxIdRegExp = new RegExp("^[a-zA-Z0-9-]{5,50}$");
        public taxIdLabel: string;
        public taxId: string;
        public denominations: Meevo.Model.Denomination[] = null;
        public taxTypeFrom: Meevo.Model.TaxType[];
        public taxTypeOnto: Meevo.Model.TaxType[];

        excludeTaxItemTypeList = [Meevo.Model.TaxItemTypeEnum.Default];
        excludeRoundingModeList = [Meevo.Model.RoundingModeEnum.CashSwedish];

        constructor(
            sectionId: number,
            displayNameContentKey: string,
            template: string,
            isPrimarySection: boolean,
            handlesOwnCrud: boolean,
            baseEndpoint: string,
            sectionEndpoint: string,
            loggingService: Meevo.Components.Logging.ILoggingService,
            dataService: Meevo.Components.CommonClasses.ICommonDataService,
            noun: Meevo.Model.NounEnum = null,
            identityService: Components.Common.IIdentityService,
            protected appSettings: Meevo.Components.Common.IAppSettings,
            private modalService: Meevo.Components.Modal.IModalService,
            sectionSecurityKey: string) {
            super(sectionId, displayNameContentKey, template, isPrimarySection, handlesOwnCrud, baseEndpoint, sectionEndpoint, loggingService, dataService, noun, identityService, sectionSecurityKey)
        }

        public activate(): void {
            this.initTax();
            super.activate();
        }

        rollbackChanges(): void {
            super.rollbackChanges();

            const tax = <Meevo.Model.Tax>this.model;
            this.taxTypeFrom = tax.taxTypes;
            this.taxTypeOnto = tax.taxTypes;
        }

        private getCountryId() {
            return this.appSettings.APP_COUNTRYID.substr(3).toUpperCase();
        }

        initTax(): any {
            const tax = <Meevo.Model.Tax>this.model;
            tax.currency = Meevo.Model.CurrencyEnum[this.appSettings.APP_ISOCURRENCYCODE];
            tax.taxPolicy = Meevo.Model.TaxPolicyEnum[this.getCountryId() + 'Tax'];

            this.taxTypeFrom = tax.taxTypes;
            this.taxTypeOnto = tax.taxTypes;

            const request = {
                criteria: {
                    currency: tax.currency
                }
            };

            this.dataService.getListPaged("denomination", request).then((response: Meevo.Model.Denomination[]) => {
                this.denominations = _(response).filter(d => d.isCashRoundingInterval);
            });
        }

        isTaxOnTaxVisible() {
            return this.getCountryId() !== 'US';
        }

        taxTypeChanged() {
            if (!this.isTaxOnTaxEnabled()) {
                const tax = <Meevo.Model.Tax>this.model;
                tax.isTaxOnTax = false;
                tax.taxAppliedFromTaxTypeId = null;
                tax.taxAppliedOntoTaxTypeId = null;
            }
        }

        isTaxIncludedInPriceEnabled() {
            const tax = <Meevo.Model.Tax>this.model;
            return !tax.isTaxOnTax;
        }

        isTaxOnTaxEnabled() {
            const tax = <Meevo.Model.Tax>this.model;
            const activeTaxTypes = _(tax.taxTypes).filter(taxType => taxType.isActive && !taxType.taxTypeFromDb);
            return activeTaxTypes.length >= 2;
        }

        isTaxOnTaxChanged() {
            const tax = <Meevo.Model.Tax>this.model;
            tax.isTaxIncludedInPrice = false;
        }

        preSave(): any {
            const tax = <Meevo.Model.Tax>this.model;
            if (!tax.isTaxOnTax) {
                tax.taxAppliedFromTaxTypeId = null;
                tax.taxAppliedOntoTaxTypeId = null;
            }

            return this.model;
        }

        taxAppliedFromChanged() {
            const tax = <Meevo.Model.Tax>this.model;
            if (tax.taxAppliedFromTaxTypeId === tax.taxAppliedOntoTaxTypeId) {
                tax.taxAppliedOntoTaxTypeId = null;
            }
        }

        taxAppliedOntoChanged() {
            const tax = <Meevo.Model.Tax>this.model;
            if (tax.taxAppliedOntoTaxTypeId === tax.taxAppliedFromTaxTypeId) {
                tax.taxAppliedFromTaxTypeId = null;
            }
        }
    }
}